import { axios } from '@/plugins/axios';
import { EventCode, LogKey, LogLevel } from '@/constants/trace';
import { AxiosResponse } from 'axios';

/**
 * Classe de service pour tracer les événements dans l'API d'usage
 */
export class TraceEventService {

    /**
     * Fait une trace dans les logs sur l'API
     *
     * @param code Code de l'évènement
     * @param level (Optionnel) Niveau de la trace (ex : INFO, DEBUG ...)
     */
    public static async trace(code: EventCode, level?: LogLevel): Promise<AxiosResponse<void>> {
        const labels = new Map<LogKey, string>([
            ['eventCode', code]
        ]);

        return axios.post('trace-event'.concat(level ? `/?level=${level}` : ''), Object.fromEntries(labels));
    }
}
